<script>
    import Vue from 'vue'

    export default {
        name: "CourseMap",
        props: {
            course: {
                type: Object,
                required: true
            },
        },
        data(){
            return {
                showMapFullscren: false,
                isMobile: window.isMobile()
            }
        },
        computed: {
            os() {
                let ua = navigator.userAgent || navigator.vendor || window.opera
                if (/windows phone/i.test(ua)) {
                    return 'windows'
                }
                if (/android/i.test(ua)) {
                    return 'android'
                }
                if (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) {
                    return 'ios'
                }
                return 'unknown'
            },
        },
        mounted() {
            window.addEventListener('resize', (e) => {
                this.$set(this, 'isMobile', window.isMobile())
                this.$refs.mapRef.$mapPromise.then((map) => {
                    google.maps.event.trigger(map, 'resize')
                    map.set('disableDefaultUI', window.isMobile())
                })
                $("#course-full-map").modal('hide')
            })
        },
        methods: {
            onZoomIn() {
                this.$refs.modalMapRef.$mapObject.setZoom(
                    this.$refs.modalMapRef.$mapObject.getZoom() + 1
                );
            },
            onZoomOut() {
                this.$refs.modalMapRef.$mapObject.setZoom(
                    this.$refs.modalMapRef.$mapObject.getZoom() - 1
                );
            },
            onOpenGoogleMaps() {
                if (this.os == 'android') {
                    location.href = `geo:${this.course.latitude},${this.course.longitude}?q=${this.course.latitude},${this.course.longitude}(${this.course.address})?q=google`
                }
                if (this.os == 'ios') {
                    location.href = `http://maps.google.com/maps?saddr=${this.course.latitude},${this.course.longitude}`
                }
            },
            toggleMapFullScreen() {
                this.showMapFullscren = !this.showMapFullscren
            },
        }

    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/course/CourseMap.vue